<template>
    
    <div class="main">
        <c-panel>
            <form-curso-superior :paramId="$route.params.id" v-on:onSubmitCursoSuperior="onSubmitCursoSuperior"></form-curso-superior>
        </c-panel>
    </div>
    
</template>
<script>

import formCursoSuperior from "./form"

export default {
    methods:{

        onSubmitCursoSuperior(){

            this.$router.push('/admin/curso-superior');  
        }
    },
    components:{ formCursoSuperior }
}
</script>
